(function(){
  if (window.__mscAmb) return; window.__mscAmb = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var phone = window.matchMedia('(max-width: 749px)');
  function load(v){
    if (v.dataset.loaded) return;
    v.src = (phone.matches && v.dataset.srcM) ? v.dataset.srcM : v.dataset.src;
    v.dataset.loaded = '1';
  }
  function setBtn(w, playing){
    w.classList.toggle('is-playing', playing);
    var b = w.querySelector('[data-mscamb-btn]');
    if (b) b.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
  }
  function play(w){
    var v = w.querySelector('video'); load(v);
    var p = v.play(); if (p && p.catch) p.catch(function(){ setBtn(w,false); });
  }
  function init(w){
    if (w.dataset.ready) return; w.dataset.ready = '1';
    var v = w.querySelector('video');
    v.addEventListener('playing', function(){ w.classList.add('is-shown'); setBtn(w,true); });
    v.addEventListener('pause', function(){ setBtn(w,false); });
    w.querySelector('[data-mscamb-btn]').addEventListener('click', function(){
      if (v.paused) { w.dataset.userPaused = ''; play(w); }
      else { w.dataset.userPaused = '1'; v.pause(); }
    });
    setBtn(w,false);
    if (!('IntersectionObserver' in window)) { if (!reduce.matches) play(w); return; }
    new IntersectionObserver(function(es){
      es.forEach(function(e){
        if (e.isIntersecting) { if (!reduce.matches && !w.dataset.userPaused) play(w); }
        else if (!v.paused) { v.pause(); }
      });
    }, { rootMargin: '200px 0px', threshold: 0.15 }).observe(w);
  }
  function all(){ document.querySelectorAll('[data-mscamb]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
})();
